import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      tickets: state.ticketsGroup.list.budgetGochis,
      totalCount: state.ticketsGroup.list.totalCount
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    tickets,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    setRowsPerPage
  }) => {
    return (
      <div className={classes.root}>
        <div className={classes.overflow}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>領収書No</TableCell>
                <TableCell>グループID</TableCell>
                <TableCell>グループ名</TableCell>
                <TableCell>メニューID</TableCell>
                <TableCell>メニュー名</TableCell>
                <TableCell>発行日</TableCell>
                <TableCell>価格</TableCell>
                <TableCell>個数</TableCell>
                <TableCell>決済金額</TableCell>
                <TableCell>予算対象月</TableCell>
                <TableCell>ごちURL</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets &&
                tickets.map(ticket => (
                  <TableRow>
                    <TableCell>
                      {(() => {
                        if (ticket.status === 1) return `${ticket.gochiBillNo}`;
                        if (ticket.status === 2) return '発行失敗';
                        return '処理中';
                      })()}
                    </TableCell>
                    <TableCell>{ticket.groupId}</TableCell>
                    <TableCell>{ticket.groupName}</TableCell>
                    <TableCell>{ticket.menuId}</TableCell>
                    <TableCell>{ticket.menuName}</TableCell>
                    <TableCell>{ticket.createdAt}</TableCell>
                    <TableCell>{ticket.menuIncludedTaxPrice}</TableCell>
                    <TableCell>{ticket.quantity}</TableCell>
                    <TableCell>{ticket.chargeAmount}</TableCell>
                    <TableCell>{`${ticket.year}/${ticket.month}`}</TableCell>
                    <TableCell>
                      {(() => {
                        if (ticket.status === 1) return `${ticket.inviteUrl}`;
                        if (ticket.status === 2) return '発行失敗';
                        return '処理中';
                      })()}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <ExPaginationGroup
          count={
            totalCount % rowsPerPage > 0
              ? Math.floor(totalCount / rowsPerPage) + 1
              : Math.floor(totalCount / rowsPerPage)
          }
          selectedPage={page}
          handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
          limit={rowsPerPage}
          totalCount={totalCount}
          setLimit={setRowsPerPage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
